import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GeoJsonFile } from '../models/hexagon-geojson.model';


@Injectable({
  providedIn: 'root'
})
export class ZonasRiesgoService {

    constructor(private httpClient: HttpClient) {}

    
   public getZonas(riskLevel?: string): Observable<GeoJsonFile> {
    const mappingFile: any = {
      critical: 'assets/sitrack_hexagons_critical.geojson',
      high: 'assets/sitrack_hexagons_high.geojson',
      medium: 'assets/sitrack_hexagons_medium.geojson',
      low: 'assets/sitrack_hexagons_low.geojson'
    };
    const key = (riskLevel || 'critical').toLowerCase();
    const file = mappingFile[key] || mappingFile['critical'];
    return this.httpClient.get<GeoJsonFile>(file);
  }


}
